import { render, staticRenderFns } from "./Lectures.vue?vue&type=template&id=27702880&scoped=true&"
import script from "./Lectures.vue?vue&type=script&lang=js&"
export * from "./Lectures.vue?vue&type=script&lang=js&"
import style0 from "./Lectures.vue?vue&type=style&index=0&id=27702880&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27702880",
  null
  
)

export default component.exports